import React from 'react';
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md';
import { text } from '../text';

const CheckBoxIcon = MdCheckBox as any;
const CheckBoxOutlineBlankIcon = MdCheckBoxOutlineBlank as any;

// Pilihan "dokumen bersama grup perjalanan" di form Request / Recap / Time Sheet — dokumen tampil
// & bisa diedit dari semua task di grup. Hanya dirender kalau task asal tergabung di grup.
export const SharedDocToggle: React.FC<{ checked: boolean; onChange: (v: boolean) => void; label?: string; hint?: string }> = ({ checked, onChange, label, hint }) => (
  <div
    onClick={() => onChange(!checked)}
    style={{
      display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer',
      padding: '10px 14px', borderRadius: 12,
      border: `1px solid ${checked ? '#7DD3FC' : '#E5E7EB'}`,
      backgroundColor: checked ? '#F0F9FF' : '#fff',
    }}
  >
    {checked ? <CheckBoxIcon size={22} color="#0284C7" /> : <CheckBoxOutlineBlankIcon size={22} color="#9CA3AF" />}
    <div style={{ flex: 1 }}>
      <text.T14 style={{ fontWeight: '600', color: checked ? '#0369A1' : '#374151' }}>{label}</text.T14>
      {hint && <text.T12 style={{ color: '#6B7280', display: 'block' }}>{hint}</text.T12>}
    </div>
  </div>
);

export default SharedDocToggle;
